import axios from "axios";
import {authHeader} from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;
  
const getCustomers = (params) => {
  return axios.get(API_URL + '/api/customerLists', { 
    params: params,
    headers: authHeader() });
};

const addCustomer = async (formData) => {
  const response = await axios.post(API_URL + "/api/customerLists", formData, {  
    headers: authHeader()
  });
  return response.data;
};

const updateCustomer = async (c_id,  formData ) => {
  const response = await axios.put(API_URL + `/api/customerLists/${c_id}`, formData, {
    headers: authHeader()
  });
  return response.data; 
};

const getCustomerByid = (c_id) => {
  return axios.get(API_URL + `/api/customerLists/${c_id}`, { 
    headers: authHeader() });
    
};

const getInactiveEmployees = (params) => {
  return axios.get(API_URL + '/api/users/inactive', { 
    params: params,
    headers: authHeader() });
};

const updateCustomerSubscription = async ( id, subscriptionPlan ) => {
  return axios.put(API_URL +`/api/customer/register/${id}`, {
    subscriptionPlan,
  });
};

const getCustomerById = (id) => {
  return axios.get(API_URL + `/api/customer/byid/${id}`, { 
    headers: authHeader() });
    
};

// Export Customer 

// Customer as CSV
const exportCustomerAsCsv = async (params) => {
  return axios.get(API_URL + '/api/leads/cusexport/csv', {
      params: params,
      headers: authHeader()
  });
}

// Customer as Excel
const exportCustomerAsExcel = async (params) => {
  return axios.get(API_URL + '/api/leads/cusexport/excel', {
      params: params,
      headers: authHeader()
  });
}

// Import Customer

const importCustomers = async (formData) => {
  const response = await axios.post(API_URL + "/api/leads/cusimport/upload-leads", formData, {
      headers: authHeader()
  });
  return response.data;
}; 

const CUSTOMERAPI={
  getCustomers,
  addCustomer, 
  updateCustomer,
  getInactiveEmployees,
  getCustomerByid,
  updateCustomerSubscription,
  getCustomerById,
  exportCustomerAsCsv,
  exportCustomerAsExcel,
  importCustomers
}

export default CUSTOMERAPI;